import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Film, LogOut, Briefcase, User, Wallet } from 'lucide-react';
import { cn } from '@/lib/utils';

const navLinkClass = ({ isActive }) =>
  cn(
    'flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors',
    isActive ? 'bg-[#0E76FF]/20 text-white' : 'text-white/70 hover:bg-white/10 hover:text-white'
  );

const UserAppShell = ({ role }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const base = role === 'client' ? '/cliente' : '/videomaker';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems =
    role === 'client'
      ? [
          { to: `${base}/jobs`, label: 'Meus jobs', icon: Briefcase },
          { to: `${base}/perfil`, label: 'Perfil', icon: User },
        ]
      : [
          { to: `${base}/jobs`, label: 'Jobs', icon: Briefcase },
          { to: `${base}/financeiro`, label: 'Financeiro', icon: Wallet },
          { to: `${base}/perfil`, label: 'Perfil', icon: User },
        ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0f1a] via-[#0d1528] to-[#0a0f1a] text-white">
      <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0a0f1a]/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6">
          <div className="flex items-center gap-3">
            <Film className="h-7 w-7 text-[#0E76FF]" />
            <div>
              <p className="text-sm font-semibold">Ufokko</p>
              <p className="text-xs text-white/50">{user?.nome}</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={handleLogout} className="text-white/80">
            <LogOut className="h-4 w-4 mr-1" />
            Sair
          </Button>
        </div>
      </header>

      <div className="mx-auto flex max-w-6xl gap-6 px-4 py-6 md:px-6">
        <aside className="hidden w-52 shrink-0 md:block">
          <nav className="space-y-1 rounded-2xl border border-white/10 bg-white/5 p-3 backdrop-blur-md">
            {navItems.map(({ to, label, icon: Icon }) => (
              <NavLink key={to} to={to} className={navLinkClass}>
                <Icon className="h-4 w-4" />
                {label}
              </NavLink>
            ))}
          </nav>
        </aside>

        <main className="min-w-0 flex-1 pb-20 md:pb-6">
          <Outlet />
        </main>
      </div>

      <nav className="fixed bottom-0 left-0 right-0 z-40 flex border-t border-white/10 bg-[#0a0f1a]/95 backdrop-blur-xl md:hidden">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex flex-1 flex-col items-center gap-1 py-3 text-xs',
                isActive ? 'text-[#0E76FF]' : 'text-white/60'
              )
            }
          >
            <Icon className="h-5 w-5" />
            {label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default UserAppShell;
